import { forwardRef } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { FormHelperText } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MultiSelect = forwardRef(({ value, onChange, className, id, label, maxHeight, items, selectAll, errors, required, infoText }, ref) => 
{ 
	const useLabel = required && label ? label + " *" : label;
  const valueMap= {};
  const values=[];
  items.map((item) => {
	  valueMap[item.value]= item.name;
	  values.push(item.value);
  });
  if (value == null) throw new Error("Value for multi-select cannot be null (" + label + ")");
  
  // Filter out invalid values (values not in current items list)
  const validValue = value.filter(v => valueMap[v] !== undefined);
  
  // Auto-clean invalid values on mount/update
  if (validValue.length !== value.length) {
    // Trigger onChange to update the form with cleaned values
    setTimeout(() => {
      const syntheticEvent = { target: { value: validValue } };
      onChange(syntheticEvent);
    }, 0);
  }
  
  const allSelected= validValue.length === items.length;
  const someSelected= validValue.length > 0 && validValue.length < items.length;
  
  const MenuProps = {
  PaperProps: {
     style: {
       maxHeight: maxHeight ? Number(maxHeight) : ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
     },
    },
  };

  const handleChange = (event) => {
		const val= event.target.value;
		let newValue= typeof val === 'string' ? val.split(',') : val; // On autofill we get a stringified value.
		if (newValue.indexOf("all") > -1) {
		    newValue= validValue.length === items.length ? [] : values; //toggle all or none
		}
		// Filter out any invalid values
		newValue = newValue.filter(v => valueMap[v] !== undefined);
    const out = { ...event, target: {...event.target, value: newValue }};
    onChange(out);
  };
  
    return (
	    <FormControl fullWidth variant="outlined" className={className}>
	      {label && <InputLabel id={"select-label-" + id}>{useLabel}</InputLabel> }
	      <Select
	        labelId={label ? "select-label-" + id : undefined}
	        label={useLabel}
	        id={id}
	        value={validValue}
	        data-testid={`select-${id}`}
	        onChange={handleChange}
	        renderValue={(selected) => selected.filter(v => valueMap[v]).map((value) => valueMap[value]).join(', ')}
	        ref={ref}
	        error={errors && !!errors[id]}
	        classes={{ select: 'flex items-center space-x-12' }}
	        MenuProps={MenuProps}
	        multiple
	      >
	        {selectAll && (
			  <MenuItem value="all" key="all">
			    <Checkbox
			        checked={allSelected}
			        indeterminate={someSelected}
			    />
			    <ListItemText primary="Select All" />
			  </MenuItem>
			)}
	        {items.map((item) => (
	          <MenuItem value={item.value} key={item.value} >
	            <Checkbox checked={validValue.indexOf(item.value) > -1} />
                <ListItemText primary={item.name} />
	          </MenuItem>
	        ))}
	      </Select>
	      {errors && !!errors[id] && <FormHelperText>{errors[id]?.message}</FormHelperText> }
	      {(!errors || !errors[id]) && infoText && <FormHelperText>{infoText}</FormHelperText> }

	    </FormControl>
	  );
});


export default MultiSelect;


